import * as React from 'react';
import { toUnicode } from 'punycode.js';
import { useDispatch } from 'react-redux';
import { useTranslator } from '@gandi/translate';
import { selectCountItemsPessimistic } from '../../components/CartWidget/modules/selectors';
import { useAppSelector } from '../../hooks/useAppSelector';
import { selectCartUUID } from '../selectors';
import { fetchCartWidgetSuggestions, resource } from './actions';
import { selectCartWidgetSuggestions } from './selectors';
export function useCartWidgetSuggestions() {
  const dispatch = useDispatch();
  const cartId = useAppSelector(selectCartUUID);
  const suggestions = useAppSelector(state => selectCartWidgetSuggestions(state, cartId));
  const isFailure = useAppSelector(state => resource.selectIsFailure(state, {
    label: cartId
  }));
  const isFetching = useAppSelector(state => resource.selectIsFetching(state, {
    label: cartId
  }));
  const isLoaded = useAppSelector(state => resource.selectIsLoaded(state, {
    label: cartId
  }));
  const isToRefetch = useAppSelector(state => resource.selectIsToRefetch(state, {
    label: cartId
  }));
  const shouldFetch = useAppSelector(state => resource.selectShouldFetch(state, {
    label: cartId
  }));
  const countItems = useAppSelector(selectCountItemsPessimistic);
  React.useEffect(() => {
    if (shouldFetch && cartId && countItems > 0 && countItems < 5) {
      dispatch(fetchCartWidgetSuggestions(cartId));
    }
  }, [shouldFetch, cartId, countItems, dispatch]);
  return {
    isFailure,
    isFetching,
    isLoaded,
    isToRefetch,
    suggestions
  };
}
export function useSuggestionTexts(product) {
  const {
    __
  } = useTranslator();
  const {
    product_type
  } = product;
  const defaultText = {
    title: product_type
  };
  const localTexts = {
    domain: {
      title: product.payload.fqdn ? toUnicode(product.payload.fqdn) : product_type
    },
    paas: {
      title: __('Web Hosting – %(size)s', {
        size: (typeof product.payload.size === 'string' && product.payload.size || '').toUpperCase()
      }),
      description: __('1 year, data stored in France'),
      details: __('Simply and easily host your website with our transparent, scalable, secure solution')
    },
    certificate: defaultText,
    cloud: defaultText,
    corporate: defaultText,
    domain_option: defaultText,
    mailboxv2: defaultText,
    'mailbox-standalone': defaultText,
    marketplace: defaultText,
    phone_advisory: defaultText,
    tmch: defaultText
  };
  return localTexts[product_type] || defaultText;
}